import {PersonnelDocumentTitle} from 'src/app/personnel/personnelHelpers';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

import {
  ModuleEnum,
  PermissionOperationEnum,
  UserTypeEnum,
} from 'src/api/ProactApiClient';
import {PersonnelForm} from 'src/app/personnel/PersonnelForm/PersonnelForm';
import type {ViewModeType} from 'src/shared/services/RouterService/IRouteService';
import {VendorListPersonnelRouteService} from 'src/shared/services/RouterService/VendorListPersonnelRouteService';

import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

export const VendorPersonnelListCreatePage = () => {
  useSetDocumentTitle(PersonnelDocumentTitle);

  const mode: ViewModeType = 'create';
  const router = new VendorListPersonnelRouteService(false, mode, {
    view: 'overview',
  });

  return (
    <PersonnelForm
      mode={mode}
      userType={UserTypeEnum.Contractor}
      view={'overview'}
      enableEdit={true}
      router={router}
    />
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.VendorListPersonnelCreate(),
  element: <VendorPersonnelListCreatePage />,
  module: ModuleEnum.Personnel,
  operation: PermissionOperationEnum.Create,
  isPrivate: true,
});

export default VendorPersonnelListCreatePage;
